// styled.ts
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { ButtonPosition } from "./AppActionSection";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  borderColor: colors.gray200,
  borderWidth: "1px",
  borderStyle: "solid",
}));

export const Title = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "28px",
  color: colors.gray700,
}));

export const Body = styled("div")(() => ({
  display: "flex",
  padding: "24px 24px 16px 24px",
  flexDirection: "column",
  gap: "16px",
  borderBottom: `1px solid #E4E7EC`,
}));

// Container principal dos botões - agora com três seções
export const ActionSection = styled("div")(() => ({
  display: "flex",
  padding: "16px 24px",
  width: "100%",
  flexWrap: "wrap", // Para responsividade em telas pequenas
}));

// Componente para cada grupo de ações (left, center, right)
export const ActionGroup = styled("div")<{ position: ButtonPosition }>(({ position }) => ({
  display: "flex",
  gap: "12px", // Espaçamento entre os botões do mesmo grupo
  flex: position === "center" ? "1 0 auto" : "0 0 auto",
  justifyContent:
    position === "left" ? "flex-start" : position === "center" ? "center" : "flex-end",

  // Garante que o grupo da direita sempre ocupe pelo menos 1/3 do espaço
  // mesmo se não houver botões no centro
  ...(position === "right" && {
    flex: "1 0 auto",
    justifyContent: "flex-end",
  }),

  // Garante que o grupo da esquerda sempre ocupe pelo menos 1/3 do espaço
  // mesmo se não houver botões no centro
  ...(position === "left" && {
    flex: "1 0 auto",
    justifyContent: "flex-start",
  }),

  // Para responsividade em telas pequenas
  "@media (max-width: 600px)": {
    flex: "1 0 100%",
    justifyContent:
      position === "left" ? "flex-start" : position === "center" ? "center" : "flex-end",
    marginBottom: position !== "right" ? "8px" : 0,
  },
}));
